<template>
  <SfButton
    class="cart-icon sf-button--outline"
    aria-label="Cart"
    @click="toggleCartSidebar"
  >
    <wm-icon
      name="cart-shopping"
      :label="$t('Cart')"
      :width="iconWidth"
      :height="iconHeight"
      class="site-header-bar--icon"
    />
    <span class="cart-icon--label desktop-only">
      {{ $t("Cart") }}
    </span>
    <SfBadge v-if="cartTotalItems" class="sf-badge--number cart-icon--badge">
      {{ cartTotalItems }}
    </SfBadge>
  </SfButton>
</template>
<script>
import { defineComponent, onMounted, computed } from "@nuxtjs/composition-api";
import { SfButton, SfBadge } from "@storefront-ui/vue";
import { useCart } from "@wemade-vsf/customer";
import { useUiState } from "@wemade-vsf/composables";

export default defineComponent({
  name: "CartIcon",
  props: {
    iconHeight: {
      type: String,
      default: "27",
    },
    iconWidth: {
      type: String,
      default: "27",
    },
  },
  components: {
    SfBadge,
    SfButton,
  },
  setup() {
    const { toggleCartSidebar } = useUiState();
    const { loadTotalQty: loadCartTotalQty, cart } = useCart();
    const cartTotalItems = computed(() => cart.value?.total_quantity || 0);

    onMounted(async () => {
      await loadCartTotalQty();
    });

    return {
      cartTotalItems,
      toggleCartSidebar,
    };
  },
});
</script>
<style lang="scss" scoped>
.cart-icon {
  position: relative;
  height: 100%;

  &:not(.header-button) {
    --button-color: var(--main-menu-link);
  }

  &--label {
    margin-left: 0.5rem;
  }

  &--badge {
    --badge-min-width: 1.5rem;
    --badge-min-height: var(--badge-min-width);
    line-height: var(--badge-min-width);
    border-radius: 50%;
    width: var(--badge-min-width);
    height: var(--badge-min-width);
    color: var(--microcart-icon-badge-color, var(--c-primary));
    background: var(--microcart-icon-badge-bg, var(--c-white));
    font-weight: var(--font-weight--normal);
    padding: 0;
    margin-left: 0.5rem;

    @include for-mobile {
      position: absolute;
      top: -0.75rem;
      right: -0.75rem;
    }
  }
}
</style>
